// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, func, number, object, oneOfType, string } from 'prop-types'
import DataHeader from './DataHeader'
import DataContainer from './DataContainer'
import { DataTableWrapper } from './styles'

// NOTE - <DataTable /> is real simple.
// It holds no state and requires that its parent
// feed it data, columns, and event handlers
// for sorting and clicking a row.

// NOTE - DataTableWrapper is not a <table />
// It wraps the table with a <div /> so we can handle
// horizontal scrolling and sticky columns/headers as necessary

// props:
// rowClass - takes a string of a function and allows you to assign CSS classes to each row of the table.

const DataTable = props => {
  const {
    className,
    columns,
    customHeader,
    data,
    handleSort,
    handleRowClick,
    minWidth,
    rowClass,
    tableSort,
    uniqueKey,
  } = props

  return (
    <DataTableWrapper
      className={className}
      minWidth={minWidth}>
      <table>
        <DataHeader
          columns={columns}
          customHeader={customHeader}
          handleSort={handleSort}
          tableSort={tableSort} />
        <DataContainer
          columns={columns}
          data={data}
          handleRowClick={handleRowClick}
          rowClass={rowClass}
          uniqueKey={uniqueKey} />
      </table>
    </DataTableWrapper>
  )
}

DataTable.propTypes = {
  className: string,
  columns: array.isRequired,
  customHeader: func,
  data: array.isRequired,
  handleSort: func,
  handleRowClick: func,
  minWidth: oneOfType([
    number,
    string,
  ]),
  rowClass: oneOfType([
    func,
    string,
  ]),
  tableSort: object,
  uniqueKey: string,
}

export default DataTable
